/**
 * BentoBoxCell CVA variants — background, padding, grid span.
 *
 * Desktop/tablet: normal `col-span` / `row-span`. Below `md`, spans are overridden
 * so every cell is one full-width row (avoids implicit grid columns from col-span>1 on a 1-col track).
 */

import { cva, type VariantProps } from 'class-variance-authority';

export const bentoCellVariants = cva(
  [
    'rounded-xl min-h-0 relative isolate z-0',
    'max-md:col-span-full max-md:row-span-1',
    'max-md:overflow-hidden',
  ].join(' '),
  {
    variants: {
      padding: {
        default: 'p-bento-info-box-padding',
        none: [
          'p-0 overflow-hidden',
          '[&_img]:h-full [&_img]:w-full [&_img]:object-cover [&_img]:min-h-0',
        ].join(' '),
      },
      variant: {
        dark: 'bg-neutral-900 text-white',
        primary: 'bg-primary-700 text-white',
        secondary: 'bg-secondary-700 text-white',
        none: 'bg-transparent text-inherit',
      },
      colSpan: {
        1: 'col-span-1',
        2: 'col-span-2',
        3: 'col-span-3',
        4: 'col-span-4',
      },
      rowSpan: {
        1: 'row-span-1',
        2: 'row-span-2',
        3: 'row-span-3',
      },
      contentAlign: {
        start: '',
        center:
          'flex h-full min-h-0 flex-col items-center justify-center text-center gap-y-xxs',
      },
    },
    defaultVariants: {
      padding: 'default',
      variant: 'dark',
      colSpan: 1,
      rowSpan: 1,
      contentAlign: 'center',
    },
  },
);

export type BentoCellVariantProps = VariantProps<typeof bentoCellVariants>;
